import TEXT from "./text-consts";
import { ValidationRule } from "../../../models";
import escapeHtml from "../../../shared/escape-html";

export const VOUCHER_ERROR_CODES = {
    CODE_NOT_REGISTRATED: "CODE_NOT_REGISTRATED",
    EXPIRED: "EXPIRED",
    VOUCHER_AMOUNT_IS_ZERO: "VOUCHER_AMOUNT_IS_ZERO",
    VOUCHER_ALREADY_ADDED: "VOUCHER_ALREADY_ADDED",
    INVALID: "INVALID",
    VOUCHER_TOO_MANY_ATTEMPTS: "VOUCHER_TOO_MANY_ATTEMPTS",
    VOUCHER_CODE_ERROR: "VOUCHER_CODE_ERROR",
    VOUCHER_CREATED: "VOUCHER_CREATED",
    VOUCHER_INACTIVE: "VOUCHER_INACTIVE",
    VOUCHER_MISSING: "VOUCHER_MISSING",
    VOUCHER_DEFAULT_ERROR: "VOUCHER_DEFAULT_ERROR",
    DISCOUNT_ALREADY_USED: "DISCOUNT_ALREADY_USED",
    NOT_FOUND: "NOT_FOUND",
    GENERAL_ERROR: "GENERAL_ERROR",
    VOUCHER_CODE_ADDED_BUT_NOT_IN_USE: "VOUCHER_CODE_ADDED_BUT_NOT_IN_USE",
} as const;

export type VoucherErrorCode = keyof typeof VOUCHER_ERROR_CODES;

export const mapVoucherValidationErrorMessage = (status: VoucherErrorCode) =>
    TEXT.ERROR[status] || TEXT.ERROR.VOUCHER_DEFAULT_ERROR;

export const rule: ValidationRule = {
    regex: /^([CGT])-(\w{6}|\w{6}-\w{6}-\w{6})-\d{3}$/,
    required: false,
    errorMessage: mapVoucherValidationErrorMessage(VOUCHER_ERROR_CODES.INVALID),
    mask: (newCode: string, previousCode?: string) => {
        const formattedCode = (newCode || "").toUpperCase();
        const isUpdateRemovingCharacters = !!previousCode && previousCode.length > newCode.length;
        const isExpectingDash = /^(\w{1})((-\w{6}){0,3})?$/.test(formattedCode);

        if (!isUpdateRemovingCharacters && isExpectingDash) {
            // formattedCode += "-"; // Don't add dash when using the voucher field to add discount
        }

        return escapeHtml(formattedCode);
    },
};
